'use client';

import LanguageSwitcher from '@/components/layout/LanguageSwitcher';
import { motion, useReducedMotion } from 'framer-motion';
import Link from 'next/link';
import { Navbar } from 'react-bootstrap';

import { logoVariants } from './animations.js';
import './navbar.scss';

const LogoCluster = ({
  showLangSwitcher = false,
  onHomeClick = () => {},
  className = '',
  rasterImageSrc = '/icons/generic-game-desktop.png',
  imageAlt = 'Brand mark',
  brandName = 'DakarGameHub',
  siteName = '',
  siteNameShort = '',
  siteNameXs = '',
  size = 'lg',
  wordmarkPalette = '',
  currentLocale,
  languageOptionLabels = {},
  languageSwitcherAriaLabel = 'Change language',
  homeAriaLabel = 'Go to homepage',
}) => {
  const prefersReduced = useReducedMotion();
  const resolvedSiteName = siteName || brandName;
  const resolvedShortName =
    siteNameShort || brandName.split(' ')[0] || brandName;
  const resolvedXsName = siteNameXs || resolvedShortName;

  return (
    <motion.div
      className={`logo-cluster ${className}`.trim()}
      variants={logoVariants}
      initial={prefersReduced ? false : 'hidden'}
      animate={prefersReduced ? false : 'show'}
      layout
    >
      <Navbar.Brand
        as={Link}
        href="/"
        onClick={onHomeClick}
        aria-label={homeAriaLabel}
        className="logo-brand py-0 me-0"
      >
        <span className={`logo-wordmark ${wordmarkPalette} ${size}`.trim()}>
          <span className="word primary-text d-none d-mmd-inline">
            {resolvedSiteName}
          </span>
          <span className="word primary-text d-inline d-mmd-none">
            {resolvedXsName || resolvedShortName}
          </span>
        </span>
      </Navbar.Brand>
      {showLangSwitcher ? (
        <LanguageSwitcher
          currentLocale={currentLocale}
          ariaLabel={languageSwitcherAriaLabel}
          optionLabels={languageOptionLabels}
          className="mt-3"
        />
      ) : null}
    </motion.div>
  );
};

export default LogoCluster;
export { LogoCluster };
